import { Star } from "@mui/icons-material";
import { Box, Rating, Typography } from "@mui/material";

interface SmallStoreCardProps {
  imgPath: string;
  name: string;
  area: string;
  point: number;
}

function SmallStoreCard({ imgPath, name, area, point }: SmallStoreCardProps) {
  return (
    <Box
      boxShadow={3}
      borderRadius={1}
      display="flex"
      flexDirection="column"
      width="185px"
      height="230px"
    >
      <Box
        width="185px"
        height="120px"
        component="img"
        alt="store 1"
        src={imgPath}
      />
      <Box display="flex" flexDirection="column" p={1} flex={1}>
        <Box display="flex" flexDirection="column" flex={1}>
          <Typography
            fontWeight="bold"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: "2",
              WebkitBoxOrient: "vertical",
            }}
          >
            {name}
          </Typography>
          <Typography variant="subtitle2" color="#999">
            {area}
          </Typography>
        </Box>
        <Box display="flex" alignItems="center">
          <Rating
            size="small"
            value={point}
            precision={0.5}
            readOnly
            emptyIcon={<Star fontSize="inherit" style={{ color: "white" }} />}
          />
          <Typography
            variant="h4"
            color="white"
            fontWeight="bold"
            sx={{ mx: 1 }}
          >
            {point}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default SmallStoreCard;
